var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.blobUrl)?_c('video',{staticClass:"xs-12",staticStyle:{"max-width":"100%"},attrs:{"controls":""}},[_c('source',{attrs:{"type":_vm.mimetype,"src":_vm.blobUrl}})]):_c('j-spinner',{staticClass:"p8",attrs:{"size":"small"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }